import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Col, Label, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { cloneDeep } from 'lodash';
import { formSelectDefault, formSelectForMulti, getSelectErrorBorder } from '../../Components/constants/styles';
import { APIClient } from '../../helpers/ApiHeleps';
import AddGoalModal from './AddGoalModal';
import TableForGoals from './TableForGoals';
import { needValidationSchema, prepareTreeList, typeOfNeeds } from './utils';
import { useSelector } from 'react-redux';

const AddNeedAndGapModal = ({
    onCloseClick,
    show,
    modeOfAction,
    setData,
    activeSubCatId,
    setActiveSubCatId,
    initialValues,
    row,
    rowTreeList,
    fetchNeeds,
    treeList
}) => {
    const api = new APIClient();
    const userCredential = useSelector((state) => state.CommonStore.loginToken);
    // const [formValues, setFormValues] = useState(initialValues);
    const [goalForm, setGoalForm] = useState({ goal: '' });
    const [loadingObj, setLoadingObj] = useState({ cat: false, subCat: false, load: false });
    const [showGoalModal, setShowGoalModal] = useState(false);
    const [subNeedsData, setSubNeedsData] = useState([]);
    const [needId, setNeedId] = useState();
    const [needsData, setNeedsData] = useState([]);

    const fetchCatAndSubCat = async (boolVal) => {
        try {
            setLoadingObj({ ...loadingObj, cat: boolVal, subCat: !boolVal });
            let resp = await api.get(`needicdcodes/${boolVal}/${needId ? needId : 0}`, userCredential);
            if (resp?.status === 200 && resp?.data?.isSuccess) {
                boolVal ? setNeedsData(resp?.data?.data) : setSubNeedsData(resp?.data?.data);
                setLoadingObj({ ...loadingObj, cat: false, subCat: false });
            } else if (!resp?.data?.isSuccess) {
                setLoadingObj({ ...loadingObj, cat: false, subCat: false });
                toast.error('API failed try again.');
            }
        } catch (error) {
            toast.error('Something went wrong please try again');
        }
    };
    useEffect(() => {
        fetchCatAndSubCat(true);
    }, []);
    useEffect(() => {
        !!needId && fetchCatAndSubCat(false);
    }, [needId]);

    const handleGoalClose = () => {
        setShowGoalModal(false);
        setGoalForm({ goal: '' });
    };

    const handleAddingGoalToTheSub = (values, data) => {
        const copyValues = cloneDeep(values);
        const findSub = values.subCategory.find((sub) => sub.icD10Id === activeSubCatId);

        if (findSub?.goals?.find((i) => i?.goal?.toLocaleLowerCase() === data.goal?.toLocaleLowerCase())) {
            toast.error('Goal is already  available.');
            return;
        }
        const findSubIndex = values.subCategory.findIndex((sub) => sub.icD10Id === activeSubCatId);
        // THIS IS FOR THE ADDING  ACTION ITEM FOR ALREADY ADDED GOAL
        if (findSub?.goals?.length) {
            findSub.goals.push({
                goal: data.goal,
                gaps: []
            });
        } else {
            findSub.goals = [
                {
                    goal: data.goal,
                    gaps: []
                }
            ];
        }
        copyValues.subCategory[findSubIndex] = findSub;
        handleGoalClose();
        return copyValues;
    };
    const isAllSubcategoriesHaveGaols = (subCategories) => {
        return subCategories.every((i) => i.goals?.length);
    };

    const addOrUpdate = async (payLoad) => {
        try {
            setLoadingObj({ ...loadingObj, load: true });
            let resp = await api.update(`${row?.uniquelink}/needs`, userCredential, payLoad);
            if (resp.data?.isSuccess) {
                toast.success('Goal added successfully.');
                fetchNeeds();
                setLoadingObj({ ...loadingObj, load: false });
                onCloseClick();
            } else if (!resp.data?.isSuccess) {
                toast.error('Api failed please try again.');
                setLoadingObj({ ...loadingObj, load: false });
            }
        } catch (error) {
            toast.error('Something went wrong please try again');
            setLoadingObj({ ...loadingObj, load: false });
        }
    };

    const submitHandler = (values) => {
        let typeForNeed = typeOfNeeds.custom;
        let untaggedArr = rowTreeList?.filter((item) => item?.needType === typeOfNeeds.untag);
        let taggedArr = rowTreeList?.filter((item) => item?.needType !== typeOfNeeds.untag);

        if (initialValues?.category?.icD10Id) {
            let obj = taggedArr?.find((item) => item?.needCategoryIcd10Id === initialValues?.category?.icD10Id);
            typeForNeed = obj?.needType;
        }
        if (!isAllSubcategoriesHaveGaols(values.subCategory)) {
            toast.error('Each sub category should have atleast one goal.');
            return;
        }
        let payLoad = {
            uniqueLink: row?.uniquelink
        };
        let newArr = prepareTreeList(taggedArr, false);

        if (untaggedArr?.length) {
            untaggedArr?.forEach((item) => {
                newArr.push({ ...item });
            });
        }

        values?.subCategory?.forEach((item) => {
            newArr.push({
                needCategoryIcd10Id: values?.category?.icD10Id,
                needSubCategoryIcd10Id: item?.icD10Id,
                goals: item?.goals?.map((e) => e?.goal),
                needType: typeForNeed
            });
        });

        if (modeOfAction === 'Add Goal') {
            const groupedByCategory = newArr?.reduce((res, item) => {
                const category = item?.needCategoryIcd10Id + '-' + item?.needSubCategoryIcd10Id + '-' + item?.needType;
                if (!res[category]) {
                    res[category] = [];
                }
                res[category].push(item);
                return res;
            }, {});

            let finalValue = Object.keys(groupedByCategory)?.map((item) => {
                let [catId, subCatId, needTypeValue] = item?.split('-');

                return {
                    needCategoryIcd10Id: catId,
                    needSubCategoryIcd10Id: subCatId,
                    goals: groupedByCategory[item]?.map((e) => e.goals)?.flat(),
                    needType: Number(needTypeValue)
                };
            });

            payLoad['needs'] = [...finalValue];
        } else {
            payLoad['needs'] = [...newArr];
        }
        addOrUpdate(payLoad);
    };

    const checkUntagSubCategory = (valueObj) => {
        const ids = valueObj?.map((ele) => ele?.icD10Id);
        let subcatObj = rowTreeList?.filter((item) => ids.includes(item?.needSubCategoryIcd10Id) && item?.needType === typeOfNeeds.untag);
        let sameSubcatObj = rowTreeList?.filter((item) => ids.includes(item?.needSubCategoryIcd10Id));
        if (subcatObj?.length) {
            toast.error('Needs cannot be added since the subcategory is untagged.');
            return false;
        }
        if (sameSubcatObj?.length) {
            toast.error('Subcategory is already exist.');
            return false;
        }
        return true;
    };
    return (
        <>
            <Modal isOpen={show} toggle={onCloseClick} size="lg" centered={true}>
                <ModalHeader className="bg-soft-primary">Add Need </ModalHeader>
                <ModalBody className="px-5 py-3">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={needValidationSchema}
                        onSubmit={(values) => {
                            submitHandler(values);
                        }}
                    >
                        {({ setFieldValue, values, errors, handleSubmit, touched, handleBlur }) => (
                            <>
                                <Row>
                                    <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4} className="mb-4">
                                        <Label className="col-form-label w-20">
                                            Category
                                            <span className="text-danger">*</span>
                                        </Label>
                                        {modeOfAction === 'Add Goal' ? (
                                            <h5>{values?.category?.icD10Desc || ''}</h5>
                                        ) : (
                                            <Select
                                                id="category"
                                                value={values.category}
                                                onChange={(e) => {
                                                    setNeedId(e ? e.icD10Id : '');
                                                    e && setSubNeedsData([]);
                                                    e && setFieldValue('subCategory', '');
                                                    setFieldValue('category', e);
                                                }}
                                                isClearable
                                                className="w-100"
                                                isLoading={loadingObj.cat}
                                                name="category"
                                                options={needsData}
                                                placeholder={'Select'}
                                                getOptionLabel={(e) => e.icD10Desc}
                                                getOptionValue={(e) => e.icD10Desc}
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                                isDisabled={false}
                                                styles={{
                                                    ...formSelectDefault,
                                                    ...getSelectErrorBorder(!!errors.category && touched.category)
                                                }}
                                            />
                                        )}
                                    </Col>

                                    <Col xs={8} sm={8} md={8} lg={8} xl={8} xxl={8} className="mb-4">
                                        <Label className="col-form-label w-20">
                                            Subcategory
                                            <span className="text-danger">*</span>
                                        </Label>
                                        {modeOfAction === 'Add Goal' || modeOfAction === 'Add Action Item' ? (
                                            <h5>{values?.subCategory[0]?.icD10Desc || ''}</h5>
                                        ) : (
                                            <Select
                                                id="subCategory"
                                                value={values.subCategory}
                                                onChange={(e) => {
                                                    if (e && checkUntagSubCategory(e)) {
                                                        setFieldValue('subCategory', e);
                                                        if (!needId) {
                                                            const findNeedId = needsData.find(
                                                                (need) => need.icD10Id === e[0].parentICD10Id
                                                            );
                                                            setNeedId(findNeedId.icD10Id);
                                                            setFieldValue('category', findNeedId);
                                                        }
                                                        setActiveSubCatId('');
                                                    }
                                                }}
                                                classNamePrefix="need"
                                                className="w-100"
                                                name="subCategory"
                                                options={subNeedsData}
                                                isLoading={loadingObj.subCat}
                                                placeholder={'Select'}
                                                getOptionLabel={(e) => e.icD10Desc}
                                                getOptionValue={(e) => e.icD10Desc}
                                                isMulti
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                                styles={{
                                                    ...formSelectForMulti,
                                                    ...getSelectErrorBorder(!!errors.subCategory && touched.subCategory)
                                                }}
                                            />
                                        )}
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mb-4">
                                        <div>
                                            <Nav className="d-flex flex-nowrap">
                                                {!!values?.subCategory?.length &&
                                                    values?.subCategory?.map((subCat, index) => (
                                                        <NavItem>
                                                            <NavLink
                                                                onClick={() => {
                                                                    setActiveSubCatId(subCat?.icD10Id);
                                                                }}
                                                                className={`cursor-pointer d-flex align-items-center ps-0 pe-8 border-bottom border-5 ${
                                                                    activeSubCatId === subCat?.icD10Id && ' border-primary'
                                                                }`}
                                                            >
                                                                {subCat?.icD10Desc || ''}
                                                            </NavLink>
                                                        </NavItem>
                                                    ))}
                                            </Nav>
                                            {!!values?.subCategory?.length && activeSubCatId && (
                                                <>
                                                    {/* {!!values?.subCategory.find((i) => i.icD10Id === activeSubCatId)?.goals?.length && ( */}
                                                    <h5 className="mt-2 d-flex align-items-center justify-content-end">
                                                        Add Goal
                                                        <i
                                                            class="ri-add-circle-fill ms-2 text-primary fs-24 cursor-pointer"
                                                            onClick={() => setShowGoalModal(true)}
                                                        />
                                                    </h5>
                                                    {/* )} */}

                                                    <TableForGoals
                                                        subCategories={values.subCategory?.find((sub) => sub.icD10Id === activeSubCatId)}
                                                        // showGapsModal={showGapsModal}
                                                        // handleAddingActionItemToGoal={handleAddingActionItemToGoal}
                                                        // handleOpeningGapsModal={handleOpeningGapsModal}
                                                        // handleAddGoalModal={handleAddGoalModal}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                <div className="mt-4 float-right  d-flex">
                                    <button
                                        type="button"
                                        className="btn btn-md btn-primary "
                                        data-bs-dismiss="modal"
                                        onClick={handleSubmit}
                                        id="needSave"
                                        disabled={loadingObj.load}
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-md ms-3 btn-outline-primary"
                                        id="goalCancel"
                                        onClick={onCloseClick}
                                    >
                                        Cancel
                                    </button>
                                </div>
                                {showGoalModal && (
                                    <AddGoalModal
                                        show={showGoalModal}
                                        onCloseClick={() => {
                                            setShowGoalModal(false);
                                            setGoalForm({ goal: '' });
                                        }}
                                        goalFormObj={goalForm}
                                        handleSucess={(data) => {
                                            setFieldValue('subCategory', [...handleAddingGoalToTheSub(values, data)]);
                                        }}
                                        treeList={treeList}
                                        // editGoalObj={editGoalObj}
                                    />
                                )}
                            </>
                        )}
                    </Formik>
                </ModalBody>
            </Modal>
        </>
    );
};

export default AddNeedAndGapModal;
